import React, { useCallback, useEffect, useState } from "react";
import { Container, Card, CardBody } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Sorting from "../../assets/images/icons/sort.png";
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import AddProjectTypeDrawer from "../../Components/Settings/addProjectTypeDrawer";
import { Action, DefaultPerPageValue, PerPage } from "../../constants/Common";
import { useSelector } from "react-redux";
import { getProjectType, removeProjectType } from "../../api/casp/projectType";
import NodataFound from "../../Components/Common/NoDataFound";
import { Col, Row } from "reactstrap"
import { CircularProgress, Skeleton } from "@mui/material";
import { debounce } from "@mui/material";
import StatusBadge from "../../Components/Badge/statusBadge";
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
import { hasModulePermission } from "../../helpers/permission";
import { Modules } from "../../constants/Module";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { Helmet } from 'react-helmet';
import { getIconPath } from "../../helpers/file_helper";
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { withTranslation } from "react-i18next";

function ProjectType(props) {
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
    const [rowCountState, setRowCountState] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [sortModel, setSortModel] = useState([]); // Sorting state
    const [triggerElement, setTriggerElement] = useState(+new Date())
    const loggedInUser = useSelector((state) => state.Profile.user)
    const [columnData, setColumnData] = useState([])
    const [rowData, setRowData] = useState([])
    const [action, setAction] = useState();
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false)
    const [projectTypeId, setProjectTypeId] = useState()
    const [state, setState] = useState({
        right: false,
    });
    const [searchItem, setSearchItem] = useState()

    const hasCreatePermissionForProjectType = hasModulePermission(Modules.PROJECT_TYPE, Action.CREATE)
    const hasEditPermissionForProjectType = hasModulePermission(Modules.PROJECT_TYPE, Action.EDIT)
    const hasDeletePermissionForProjectType = hasModulePermission(Modules.PROJECT_TYPE, Action.DELETE)

    useEffect(() => {
        fetchProjectTypeList()
    }, [triggerElement])

    useEffect(() => {
        if (page !== 0) {
            setPage(0)
            setTriggerElement(+new Date())
        }
    }, [rowsPerPage])

    const resetValues = () => {
        if (action === Action.EDIT) {
            setSelectedRow(null)
            setAction(Action.CREATE)
        }
        else {
            setAction(Action.EDIT)
        }
    }
    const handleToggleDrawer = (anchor, open, isItemUpdate) => (event, reason) => {
        resetValues()
        if (reason === 'backdropClick') {
            return;
        }
        if (
            event &&
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const handleClose = () => {
        resetValues()
        setState({
            right: false
        })
    }

    const handlePaginationModelChange = (newPaginationModel) => {

        if (rowsPerPage !== newPaginationModel.pageSize) {
            setRowsPerPage(newPaginationModel.pageSize);
            if (page === 0) {
                setTriggerElement(+new Date())
            }
        } else {
            setPage(newPaginationModel.page)
            setTriggerElement(+new Date())
        }
    };

    const handleSortModelChange = useCallback(async (sortModel) => {
        if (sortModel && sortModel.length > 0) {
            setSortModel(sortModel)
            setTriggerElement(+new Date())
        }
    }, []);

    const fetchProjectTypeList = async () => {
        try {
            setIsLoading(true)
            const params = {
                page: page + 1,
                perPage: rowsPerPage,
                order: sortModel[0]?.field || "updatedAt",
                direction: sortModel[0]?.sort || "desc",
                ...(searchItem && ({
                    search: searchItem
                }))
            }
            const res = (await getProjectType(params)).data.data
            const result = (res.data).map((data) => {
                return {
                    id: data?.id,
                    name: data?.name,
                    description: data?.description,
                    companyId: data?.companyId
                }
            })
            setRowData(result)
            setRowCountState(res.meta.total)
        } catch (error) {
            console.log(error)
        }
        finally {
            setIsLoading(false)
        }
    }

    const taskRefresh = async () => {
        resetValues()
        setState({
            right: false
        })
        setRowData([]);
        setPage(0)
        setTriggerElement(+new Date())
    };

    const handleDeleteClick = async (params, action) => {
        if (action === Action.DELETE) {
            setProjectTypeId(params?.id)
            setIsOpenSweetAlert(true)
        }
    };

    const deleteProjectType = async () => {
        try {
            const res = await removeProjectType(projectTypeId)
            if (res.statusCode === 200) {
                toast.success(res.data.message)
                setPage(0)
                setRowData([]);
                setTriggerElement(+new Date())
            }
        } catch (error) {
            console.log(error.message)
            toast.error(error.message)
        } finally {
            setIsOpenSweetAlert(false)
        }
    }

    useEffect(() => {
        if (hasEditPermissionForProjectType || hasDeletePermissionForProjectType) {
            setColumnData([
                {
                    field: "id",
                    headerName: "#",
                    width: 150,
                    filterable: false,
                    renderHeader: () => (
                        <div className="sno-header">
                            <img src={Sorting} alt={Sorting} />
                        </div>
                    ),
                },
                {
                    field: "name",
                    headerName: props.t("Startup Type"),
                    width: 250,
                    filterable: false,
                    sortable: true,
                    renderCell: (params) => (
                        <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
                            <div className="MuiDataGrid-cellContent">
                                <span className="m-2">{params.row?.name}</span>
                                {
                                    !params.row?.companyId && (
                                        <StatusBadge label="System" color="#9B4444" />
                                    )
                                }
                            </div>
                        </div>
                    ),
                },
                {
                    field: "description",
                    headerName: props.t("Description"),
                    width: 300,
                    cellClassName: 'description-cell',
                    filterable: false,
                    sortable: true,
                    renderCell: (params) => (
                        <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
                            <div className="MuiDataGrid-cellContent">
                                <span className="text-truncate">{params.row?.description}</span>
                            </div>
                        </div>
                    ),
                },
                {
                    field: "actions",
                    headerName: props.t("Actions"),
                    width: 150,
                    sortable: false,
                    filterable: false,
                    hideable: false,
                    renderCell: (params) => (
                        <>
                            {
                                hasEditPermissionForProjectType && params.row?.companyId && (
                                    <EditOutlinedIcon
                                        sx={{ cursor: 'pointer' }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setSelectedRow(params.row)
                                            setAction(Action.EDIT)
                                            setState({
                                                right: true
                                            })
                                        }}
                                    />
                                )
                            }
                            {
                                hasDeletePermissionForProjectType && params.row?.companyId && (
                                    <DeleteOutlineIcon
                                        sx={{ cursor: 'pointer' }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleDeleteClick(params.row, Action.DELETE)
                                        }}
                                    />
                                )
                            }
                        </>
                    ),
                }
            ]
            )
        }

        if (!hasEditPermissionForProjectType && !hasDeletePermissionForProjectType) {
            setColumnData([
                {
                    field: "id",
                    headerName: "#",
                    width: 150,
                    filterable: false,
                    renderHeader: () => (
                        <div className="sno-header">
                            <img src={Sorting} alt={Sorting} />
                        </div>
                    ),
                },
                {
                    field: "name",
                    headerName: props.t("Startup Type"),
                    width: 250,
                    filterable: false,
                    sortable: true,
                    renderCell: (params) => (
                        <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
                            <div className="MuiDataGrid-cellContent">
                                <span className="m-2">{params.row?.name}</span>
                                {
                                    !params.row?.companyId && (
                                        <StatusBadge label="System" color="#9B4444" />
                                    )
                                }
                            </div>
                        </div>
                    ),
                },
                {
                    field: "description",
                    headerName: props.t("Description"),
                    width: 300,
                    cellClassName: 'description-cell',
                    filterable: false,
                    sortable: true,
                    renderCell: (params) => (
                        <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
                            <div className="MuiDataGrid-cellContent">
                                <span className="text-truncate">{params.row?.description}</span>
                            </div>
                        </div>
                    ),
                },
            ])
        }

    }, [hasEditPermissionForProjectType, hasDeletePermissionForProjectType, props.t])

    const getRowId = (row) => row.id;
    const globalSearch = useCallback(
        debounce((searchValue) => {
            if (searchValue) {
                setSearchItem(searchValue.target.value)
                setTriggerElement(+new Date())
            }
        }, 1200), [])
    return (
        <React.Fragment>
            <div className="page-content position-relative">
                <Helmet
                    onChangeClientState={(newState, addedTags) => {
                        try {
                            // Check if we added any new link[rel="icon"] elements.
                            const newFaviconElems = filter(get(newState, 'linkTags', []), {
                                rel: 'icon',
                            })

                            if (!newFaviconElems.length) {
                                return
                            }

                            // Get the href of the last link element we just added, which
                            // we assume is the most recently-added favicon.
                            const newFaviconHref =
                                newFaviconElems[newFaviconElems.length - 1].href

                            // Remove all react-helmet link elements with rel="icon" that
                            // do not have the href of our recently-added favicon.
                            // If no other favicon elements exist, we don't have to do
                            // anything.
                            const existingFavicons = document.querySelectorAll(
                                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
                            )

                            if (existingFavicons.length) {
                                existingFavicons.forEach(e => e.parentNode.removeChild(e))
                            }

                            // Remove and re-add the latest link element to make sure
                            // the browser uses it.
                            const newFaviconElem = document.querySelector(
                                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
                            )

                            if (newFaviconElem) {
                                const newFavElement = newFaviconElem.cloneNode(true)
                                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                                    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(<SettingsOutlinedIcon />)}</svg>`
                                )}`
                                const parentElem = newFaviconElem.parentNode
                                parentElem.removeChild(newFaviconElem)
                                parentElem.appendChild(newFavElement)
                            }
                        } catch (e) {
                            console.error(e)
                        }
                    }}
                >
                    <title>{props.t("Startup Type")}</title>
                </Helmet>
                <Container fluid>
                    <div className="mainPageHeader d-flex justify-content-between">
                        <BreadCrumb
                            title={props.t("Startup Type")}
                        />

                        {/* <TextField id="outlined-basic" label="Outlined" variant="outlined" placeholder="Search..." /> */}
                        <div className="d-flex justify-content-end ongoingSearchField">
                            <Paper
                                component="form"
                                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 289, height: 40, boxShadow: 'unset', marginRight: '15px', background: '#EBEDF5'}}
                            >
                                <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                    <SearchIcon />
                                </IconButton>
                                <InputBase
                                    placeholder={props.t("Search")}
                                    inputProps={{ 'aria-label': 'search google maps' }}
                                    onChange={globalSearch}
                                />

                                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                {isLoading && rowData.length > 0 ? <CircularProgress color="inherit" size={20} /> : ""}

                            </Paper>
                            {
                                hasCreatePermissionForProjectType &&
                                <button className='edit_button d-flex justify-content-center px-3 align-items-center' onClick={handleToggleDrawer("right", true, false)}>
                                        <AddOutlinedIcon /><p className='mb-0'>{props.t("Add Startup Type")}</p>
                                    </button>
                            }
                        </div>
                    </div>
                    <div className="projectTypeTable my-2" style={{ height: 400, width: "100%" }}>
                        {
                            rowData.length > 0 && (
                                <DataGrid
                                    rows={rowData}
                                    columns={columnData}
                                    disableRowSelectionOnClick
                                    paginationMode="server"
                                    getRowId={getRowId}
                                    initialState={{
                                        pagination: {
                                            paginationModel: { pageSize: rowsPerPage },
                                        },
                                    }}
                                    pageSizeOptions={PerPage}
                                    sortingMode="server"
                                    rowCount={rowCountState}
                                    onPaginationModelChange={handlePaginationModelChange}
                                    onSortModelChange={handleSortModelChange}
                                    loading={isLoading}
                                />
                            )
                        }
                        {rowData.length === 0 && !isLoading && (
                            // <div className="text-center p-4">No data found</div>
                            <NodataFound text={props.t("No data found")} />
                        )}
                        {isLoading && rowData.length === 0 && (
                            <Col md={12}>
                                <Row className="p-2">
                                    <Col md={12}>
                                        <Skeleton
                                            variant="rounded"
                                            className="p-2 m-2 h-75"
                                        ></Skeleton>
                                    </Col>
                                </Row>
                                <Row className="p-2">
                                    <Col md={12}>
                                        <Skeleton
                                            variant="rounded"
                                            className="p-2 m-2 h-75"
                                        ></Skeleton>
                                    </Col>
                                </Row>
                                <Row className="p-2">
                                    <Col md={12}>
                                        <Skeleton
                                            variant="rounded"
                                            className="p-2 m-2 h-75"
                                        ></Skeleton>
                                    </Col>
                                </Row>
                            </Col>
                        )}
                    </div>
                </Container>
                <AddProjectTypeDrawer
                    isOpen={state["right"]}
                    handleClose={handleClose}
                    toggleDrawer={handleToggleDrawer}
                    emitItem={taskRefresh}
                    actionType={Action.CREATE}
                />
                {
                    selectedRow && action === Action.EDIT && (
                        <AddProjectTypeDrawer
                            isOpen={state["right"]}
                            handleClose={handleClose}
                            toggleDrawer={handleToggleDrawer}
                            emitItem={taskRefresh}
                            data={selectedRow}
                            actionType={action}
                        />
                    )
                }

                {/** Delete Project Type */}
                {isOpenSweetAlert && (

                    <SweetAlert
                        title={props.t("Are you sure you want to delete this startup type?")}
                        warning
                        showCancel
                        confirmBtnText={props.t("OK")}
                        cancelBtnText={props.t("Cancel")}
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={async () => {
                            await deleteProjectType()
                        }}
                        onCancel={() => {
                            setIsOpenSweetAlert(false)
                        }}>
                    </SweetAlert>
                )}
            </div>
        </React.Fragment>
    )
}

export default withTranslation()(ProjectType)